import config from '@/utils/config'

/**
 * Returns the expedient list
 * @param {*} commit Last change
 * @param {*} state  Current state
 * @param {*} getters Getters
 * @param {*} dispatch  Dispatch method
 * @return {Promise} Dispatch changes
 */
export const getExpedientList = ({ commit, state, getters, dispatch }) => {
  if (config.features.hasExpedients) {
    return dispatch('expedients/getList')
      .then(() => {
        let expedients = getters['expedients/array/items']
        expedients = expedients.map((x) => {
          x.expedient = x.id
          x.id = ''
          x.name = ''
          return x
        })
        const financeables = expedients
        commit('list/SET_LIST', financeables.sort(function(a, b) {
          return Number(a.expedient) - Number(b.expedient)
        }))
        return Promise.resolve(financeables)
      })
  } else {
    return Promise.resolve([])
  }
}

/**
 * Get list of Expedients and Agreements
 * @param {*} commit  Last change
 * @param {*} state   Current state
 * @param {*} getters Getters
 * @param {*} dispatch  Store dispatch method
 * @param {*} financial Array of invoices
 * @return {Promise} Which fetches lists
 */
export const getExpedientsAndAgreementsList = ({ commit, state, getters, dispatch }, financial) => {
  /**
   * Determines if all financial items are equal to something else
   * @param {*} option  To evaluate with
   * @return {Boolean} true if all are equal, false in other case
   */
  function allEqualTo(option) {
    return financial.every(item => item === option)
  }

  /**
   * Extracts the "expedients" from all "FACTORING" financial items
   * @return {Promise} Dispatch change
   */
  function expedients() {
    if (!financial.length || allEqualTo('FACTORING')) {
      return dispatch('expedients/getList')
      .then(() => {
        var expedients = getters['expedients/array/items']
        expedients = expedients.map((x) => {
          x.expedient = x.id
          x.id = ''
          x.name = ''
          return x
        })
        return Promise.resolve(expedients)
      })
    }
    return Promise.resolve([])
  }

  /**
   * Returns all agreements from "DISCOUNTS" financial items
   * @return {Promise} Dispatch change
   */
  function agreements() {
    if (!financial.length || allEqualTo('DISCOUNTS')) {
      return dispatch('agreements/getList')
      .then(() => {
        var agreements = getters['agreements/list/getItems']
        return Promise.resolve(agreements)
      })
    }
    return Promise.resolve([])
  }

  if (config.features.hasExpedients) {
    return Promise.all([expedients(), agreements()])
    .then((values) => {
      var financeables = [].concat.apply([], values)
      commit('list/SET_LIST', financeables.sort(function(a, b) {
        return Number(a.expedient) - Number(b.expedient)
      }))
      return Promise.resolve(financeables)
    })
  } else {
    return Promise.resolve([])
  }
}
